import { render, staticRenderFns } from "./LayoutSwitchLang.vue?vue&type=template&id=166215dc"
import script from "./LayoutSwitchLang.vue?vue&type=script&lang=js"
export * from "./LayoutSwitchLang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports